export default {
  formFields1: [],
  formFields1Order: [],
  formFields2: [],
  formFields2Order: [],
  preventCopy: true,
  selectedFieldIndex: {},
};
